<template>
  <div>
    <!--Encabezado navbar-->
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top" id="mainNav">
      <div class="container">
        <a class="navbar-brand js-scroll-trigger" href="#page-top"><img class="logo" src="static/img/logos/cabobaby only.png"
            height="20"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive"
          aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
            Menu
          <i class="fas fa-bars"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav text-uppercase ml-auto">
            <li class="nav-item">
              <a class="nav-link js-scroll-trigger" href="#services">Inicio</a>
            </li>
            <li class="nav-item">
              <a class="nav-link js-scroll-trigger" href="#portfolio">Catalogo</a>
            </li>
            <li class="nav-item">
              <a class="nav-link js-scroll-trigger" href="#About">General</a>
            </li>
            <li class="nav-item">
              <a class="nav-link js-scroll-trigger" href="#team">Team</a>
            </li>

          </ul>
        </div>
      </div>
    </nav>
    <div id="app">
      <Header/>
      <Catalogo/>
      <Modal/>
      <Showcase/>
      <Company/>
      <Foot/>
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from './components/Header'
import Catalogo from './components/Catalogo'
import Modal from './components/Modal'
import Showcase from './components/Showcase'
import Company from './components/Company'
import Foot from './components/Foot'
  export default {
    name: 'App',
    components:{
      Header,
      Catalogo,
      Modal,
      Showcase,
      Company,
      Foot
    }
  }

</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue